/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type HideReviewedFilterSchemaScope = typeof HideReviewedFilterSchemaScope[keyof typeof HideReviewedFilterSchemaScope];


export const HideReviewedFilterSchemaScope = {
  none: 'none',
  org: 'org',
  project: 'project',
  search: 'search',
} as const;
